var map = {
	"./events-cat.webp": 2084,
	"./games-cat.webp": 2085,
	"./live-casino-cat.webp": 2086,
	"./lottery-cat.webp": 2087,
	"./other-cat.webp": 2088,
	"./p2p-cat.webp": 2089,
	"./pd-table.webp": 2090,
	"./privacy-policy-title-bm.webp": 2091,
	"./privacy-policy-title-cn.webp": 2092,
	"./privacy-policy-title-id.webp": 2093,
	"./privacy-policy-title.webp": 2094,
	"./promos-1.webp": 2095,
	"./promos-2.webp": 2096,
	"./promos-3.webp": 2097,
	"./promos-4.webp": 2098,
	"./question.webp": 2099,
	"./sideBar-bg.webp": 2100,
	"./slot-cat.webp": 2101,
	"./special-cat.webp": 2102,
	"./sports-cat.webp": 2103
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 474;